<template>
  <main class="maintenance-page" role="main" aria-labelledby="maintenance-title">
    <section class="maintenance-card" aria-live="polite">
      <img
        class="maintenance-logo"
        src="./assets/images/resmed_logo.png"
        alt="ResMed"
      />

      <div class="maintenance-icon-wrap" aria-label="Maintenance in progress" role="img">
        <svg
          class="maintenance-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="38"
          height="38"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#133c63"
          stroke-width="1.75"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <path
            d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"
          />
        </svg>
      </div>

      <h1 id="maintenance-title" class="maintenance-title">We'll Be Back Soon</h1>

      <p class="maintenance-copy">
        The Global Support Site is currently undergoing scheduled maintenance.
      </p>
      <p class="maintenance-copy">
        We're working to restore the site as soon as possible. Please check back later.
      </p>

      <p class="maintenance-availability">
        <span class="maintenance-label">Expected availability:</span>
        <span class="maintenance-time">{{ expectedAvailability }}</span>
      </p>

      <a class="maintenance-cta" :href="'mailto:digital@resmed.com'">Contact Support</a>
    </section>
  </main>
</template>

<script>
const DEFAULT_AVAILABILITY = "Today, 18:00 UTC";

export default {
  name: "MaintenancePage",
  data() {
    return {
      expectedAvailability:
        process.env.VUE_APP_MAINTENANCE_EXPECTED_AVAILABILITY || DEFAULT_AVAILABILITY,
    };
  },
};
</script>

<style scoped lang="scss">
.maintenance-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 24px;
}

.maintenance-card {
  position: relative;
  z-index: 1;
  width: min(640px, 100%);
  background: #ffffff;
  border: 1px solid rgba(15, 33, 54, 0.08);
  border-radius: 24px;
  padding: 44px 30px;
  text-align: center;
  box-shadow: 0 24px 60px rgba(15, 33, 54, 0.16);
}

.maintenance-logo {
  width: 164px;
  height: auto;
}

.maintenance-icon-wrap {
  width: 82px;
  height: 82px;
  margin: 30px auto 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(150deg, rgba(229, 32, 59, 0.13), rgba(229, 32, 59, 0.04));
  border: 1px solid rgba(229, 32, 59, 0.2);
}

.maintenance-icon {
  width: 38px;
  height: 38px;
  object-fit: contain;
}

.maintenance-title {
  margin: 0;
  color: #0f2136;
  font-family: "Vastago Grotesk", "Plus Jakarta Sans", sans-serif;
  font-size: clamp(1.8rem, 3.2vw, 2.5rem);
  font-weight: 500;
  letter-spacing: -0.02em;
  line-height: 1.15;
}

.maintenance-copy {
  margin: 16px auto 0;
  max-width: 52ch;
  color: #495b70;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-size: 1.03rem;
  line-height: 1.65;
}

.maintenance-availability {
  margin: 30px 0 0;
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  padding: 11px 16px;
  border-radius: 999px;
  background: #f4f7fb;
  border: 1px solid rgba(15, 33, 54, 0.08);
  color: #0f2136;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-size: 0.95rem;
}

.maintenance-label {
  font-weight: 500;
}

.maintenance-time {
  font-weight: 700;
  color: #133c63;
}

.maintenance-cta {
  margin: 28px 8px 0;
  display: inline-block;
  border-radius: 999px;
  padding: 13px 24px;
  text-decoration: none;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 500;
  background: linear-gradient(135deg, #101010, #2b2b2b);
  color: #fff;
  box-shadow: 0 12px 24px rgba(16, 16, 16, 0.26);
  transition: transform 180ms ease, box-shadow 180ms ease;
}

.maintenance-cta:hover,
.maintenance-cta:focus-visible {
  transform: translateY(-1px);
  box-shadow: 0 16px 32px rgba(16, 16, 16, 0.3);
}

@media (max-width: 767px) {
  .maintenance-card {
    border-radius: 18px;
    padding: 34px 18px;
  }

  .maintenance-copy {
    font-size: 0.98rem;
  }

  .maintenance-availability {
    border-radius: 16px;
  }
}
</style>